import React from 'react';

import styles from './Overlay.module.scss';
import cx from 'clsx';

interface OverlayPropTypes {
  componentVisible?: boolean;
  onClick?: () => void;
}

const Overlay: React.FC<OverlayPropTypes> = ({
  componentVisible = true,
  onClick,
}) => {
  function handleClick() {
    onClick && onClick();
  }

  return (
    <div
      data-testid="overlay"
      className={cx(
        styles.overlay,
        componentVisible ? styles.showOverlay : styles.hideOverlay
      )}
      onClick={handleClick}
    />
  );
};

export default React.memo(Overlay);
